/**
 * Lightweight completed city content registry check.
 */
export const COMPLETED_CITY_SLUGS = new Set(['douala', 'yaounde']);

export function hasCompleteCityContent(citySlug) {
  if (!citySlug) return false;
  return COMPLETED_CITY_SLUGS.has(String(citySlug).toLowerCase().trim());
}
